module.exports = __webpack_public_path__ + "static/img/IMG_20160222_150000.5181af01.jpg";